import { Breadcrumb, Button, Card, Row, Steps } from 'antd'
import Existing from '../../../../components/Finance/Lender/NewLender/Form/Existing'
import WrappedContactDetails from '../../../../components/Main/Form/PersonalDetails'
import style from '../../../../components/Sales/NewClient/style.css'
import useTitle from '../../../../elements/Hooks/useTitle'
import React, { Fragment } from 'react'

const { Step } = Steps
function NewLender(props) {
  useTitle('New Client')
  const { currentStep, prev, next, skip, submit, submitting, members, formRef } = props
  const steps = [
    {
      title: 'Search for Existing',
      content: <Existing {...props} />,
    },
    {
      title: 'Personal Details',
      content: (
        <WrappedContactDetails ref={formRef} {...props} list={members.filter((m) => m.kind === 'organisation')} />
      ),
    },
  ]

  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/finance/lenders/list">Financial Partners</Breadcrumb.Item>
            <Breadcrumb.Item>New Financial Partner</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>Create new Financial Partner</h2>
          <p className={style.paragraph}>
            You can either add a new financial partner or select a member from existing contact.
          </p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Steps current={currentStep}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">{steps[currentStep].content}</div>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {currentStep > 0 && (
            <Button style={{ marginRight: 8 }} onClick={prev}>
              Previous
            </Button>
          )}
          {currentStep === 0 && (
            <Button style={{ width: '100px', marginRight: 8 }} onClick={skip}>
              Skip
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button style={{ width: '100px' }} type="primary" onClick={next}>
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button type="primary" loading={submitting} onClick={submit}>
              Create
            </Button>
          )}
        </div>
      </Card>
    </Fragment>
  )
}

export default NewLender
